import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  name: Yup.string().trim().required('msg_error_required_field'),
  company_code: Yup.string().nullable(),
});
